import { render, staticRenderFns } from "./myProfileNavDialog.vue?vue&type=template&id=385edbae&scoped=true"
import script from "./myProfileNavDialog.vue?vue&type=script&lang=js"
export * from "./myProfileNavDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385edbae",
  null
  
)

export default component.exports